export class DtoCotizacion {
    numeroDocumento: string;
    companiaSocio: string;
    fechaDocumento: Date;
    fechaVencimiento: Date;
    clienteNum: number;
    clienteNombre: string;
    coMonedaDocumento: string;
    maMonedaDocumento: string;
    montoTotal: number;
    comentarios: string;
    almacenCodigo: string;
    vendedor: number;
    vendedorNombre: string;
    descripcionLocal: string;
    estado: string;
    afectoPercepcionIGVFlag: string;
    esAprobador: string;
    esAdministrador: string;
}
